import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import isDesktopSelector from 'store/app/selector/isDesktop';

export default (({ children, and }) => {
  const isDesktop = useSelector(isDesktopSelector);
  const shouldRender = isDesktop && (and === undefined ? true : and);
  return <>{shouldRender ? children : null}</>;
}) as React.FC<PropsWithChildren<{ and?: boolean }>>;
